let pageLeaving = false

function resetOnBackForwardRestore(event) {
  if (event.persisted) pageLeaving = false
}

export function markPageLeaving() {
  pageLeaving = true
  window.addEventListener('pageshow', resetOnBackForwardRestore)
}

export function isPageLeaving() {
  return pageLeaving
}
